import FounderLogo from './FounderLogo';

export default FounderLogo;
